import { render, staticRenderFns } from "./TransmissionDisclaimer.vue?vue&type=template&id=d46e85e0&scoped=true"
var script = {}
import style0 from "./TransmissionDisclaimer.vue?vue&type=style&index=0&id=d46e85e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46e85e0",
  null
  
)

export default component.exports